import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { entranceColumns } from './StorageColumns';
import { OrderService } from '../../services/warehouse/order.service';
import { ReceptionreferenceService } from '../../services/warehouse/receptionreference.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatDate } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { select, Store } from '@ngrx/store';
import * as jwt_decode from 'jwt-decode';
import { AppState } from '../../core/reducers/index';
import { selectAuthState } from '../../core/auth/_selectors/auth.selectors';
import { LogDto } from '../../models/dto/log.dto';
import { Action } from '../../models/enums/action.enum';
import { Screen } from '../../models/enums/screen.enum';
import { LogService } from '../../services/log/log.service';
import { ResponseStorageResult } from '../../../app/models/response-result.model';

@Component({
  selector: 'kt-storage',
  templateUrl: './storage.component.html',
  styleUrls: ['./storage.component.scss']
})
export class StorageComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  storeages: ResponseStorageResult<any[]> = new ResponseStorageResult<any[]>();
  detail = [];
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any = {};
  searchForm: FormGroup;
  title: string;
  adminFilter: boolean = false;
  private sub: any;
  routeToNew: string;
  notRows: boolean;
  page: number = 1;
  payload$: any;

  constructor(
    private activeRoute: ActivatedRoute,
    private fb: FormBuilder,
    private orderService: OrderService,
    private chRef: ChangeDetectorRef,
    private toastr: ToastrService,
    private store: Store<AppState>,
    private logService: LogService,
    private receptionreferenceService: ReceptionreferenceService) {
  
  }
  showError(message) {
    this.toastr.error(message, 'Error.');
  }
  ngOnInit() {
    this.payload$ = this.store.pipe(select(selectAuthState));
    this.checkUserRole();
    this.searchForm = this.fb.group({
      statusTypeFilter: [0],
      dateFrom: '',
      dateTo: '',
      requestId: ''
    }); 
    this.routeToNew = '/warehouse-entry';
    this.title = 'Entradas de Almacén';
    this.payload$.subscribe(res => {
      let tokenData = jwt_decode(res.authToken)
      this.logService.postWithPayload(<LogDto>{
        ActionId : Action.AccederPantalla,
        ScreenId : Screen.EntradaAlmacen,
        Json : '',
        UserName: res.user.fullname,
        Email: res.user.email,
        ClientId: tokenData['https://mardom.com/clientId'] == '' ? null : tokenData['https://mardom.com/clientId'],
        RoleName:tokenData['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'][0]
      },
      res.authToken);
    })
    this.searchStorage(1,10);
  }
  onPageChange(item: number) {
    this.page = item;
    this.searchStorage(item, 10);
  }
  get pageTotal() {
    return Math.ceil(this.storeages ? this.storeages.Total / 10 : 0);
  }

  get pages(): number[] {
    let pages = [];
    for (let i = 0; i < this.pageTotal; i++) {
      pages.push(i + 1);
    }
    return pages;
  }

  checkUserRole() {
    this.store.select(selectAuthState).subscribe(result => {
      var decoded = jwt_decode(result.authToken);  
      var currentRoles =
        decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
      var internal = currentRoles.indexOf('Client');

      if (!(internal > -1)) {
        this.adminFilter = true;
      } else {
        this.adminFilter = false;
      }
    });
  }
  changeDate() {
    let fromDate = new Date(this.searchForm.value.dateFrom);
    let toDate = new Date(this.searchForm.value.dateTo);
    if (fromDate > toDate) this.searchForm.get('dateTo').setValue('');
  }

  clearFields() {
    this.searchForm = this.fb.group({
      statusTypeFilter: [0],
      dateFrom: '',
      dateTo: '',
      requestId: ''
    });
    this.searchStorage(1,10);
    this.rerender();
  }
  searchStorage(pageNumber : number,pageSize:number ) {
    var orderId =
    this.searchForm.value.requestId == ''
      ? 0
      : this.searchForm.value.requestId;
  var dateFrom =
    this.searchForm.value.dateFrom == ''
      ? null
      : this.searchForm.value.dateFrom;
  var dateTo =
    this.searchForm.value.dateTo == '' ? null : this.searchForm.value.dateTo;
  var statusTypeFilter =
    this.searchForm.value.statusTypeFilter == ''
      ? null
      : this.searchForm.value.statusTypeFilter;

    this.receptionreferenceService
      .getReferenceList(
        orderId,
        dateFrom,
        dateTo,
        statusTypeFilter,
        0,
        pageNumber,
        pageSize
      )
      .subscribe(
        data => {
          let formatedData = data['response'].map(item => {
            return {
              ...item,
              showDetail: false
            };
          });
          this.storeages.Response = formatedData;
          this.storeages.Total = data['total'];
          this.notRows = data['total'] == '0';
          this.rerender();
        },
        error => {
          this.storeages.Response = [];
          this.notRows = true;
          this.rerender();        
          switch (error.status) {
            case 400:
              this.toastr.info(
                'No tiene entradas de almacén para consultar.',
                'Aviso.'
              );
              break;
            case 401:
              this.toastr.info(
                'No tiene los permisos para realizar esta acción.',
                'Aviso.'
              );
              break;
            case 500:
              this.showError(
                'Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com'
              );
              break;
            case 403:
              this.toastr.info(
                'No tiene los permisos para realizar esta acción.',
                'Aviso.'
              );
              break;
            case 0:
              this.showError(
                'Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com'
              );
              break;
            case undefined:
              this.showError(
                'Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com'
              );
              break;
            default:
              this.toastr.error(
                'Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com'
              );
              break;
          }
        }
      );

    this.chRef.detectChanges();
  }

  rerender(): void {
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
        this.chRef.detectChanges();
      });
    } else {
      this.dtTrigger.next();
      this.chRef.detectChanges();
    }
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
